import { useGetMe } from '../queries/me/use-get-me'

export enum ExactScopeName {
  accountManager = '*:*:accountmanager',
  charter = 'vessel:*:chartering',
  maerskTankersUser = '*:*:mtuser',
  poolReporting = '*:*:mtpoolreporting',
  mtopsVessel = 'vessel:*:mtops',
  charteringUpdate = 'chartering:*:update',
  superReader = '*:*:reader',
  poolAdmin = 'pool:*:admin',
  preFixtureUpdate = 'chartering:prefixture:update',
  distCalc = 'feature:distcalc',
  technicalManagement = '*:*:technicalmanagement',
  portInfoRead = 'page:portinfo:read',
  portInfoWrite = 'page:portinfo:write',
  uploadPoolDocuments = 'feature:upload-pool-documents',
  notificationWriter = 'settings:notifications:write',
  welcomePopupWriter = 'settings:welcomepopup:write',
  incidentsWriter = 'ops:incidents:write',
  dryDockWriter = 'ops:dry-dock:write',
  vesselProfileWriter = 'ops:vessel-profile:write',
  clausesWriter = 'settings:clauses:write',
  helpWriter = 'settings:help:write',
  newsWriter = 'news:*:write',
  poolFilesWriter = 'files:pool:write',
}

export function useGetScope() {
  const { data } = useGetMe()
  return data?.scope || []
}

export function useHasScope(...scope: (ExactScopeName | string | RegExp)[]) {
  const { data } = useGetMe()
  return (
    data?.scope.some((item: string) => {
      return scope.some((ii) =>
        ii instanceof RegExp ? ii.test(item) : ii === item,
      )
    }) ?? false
  )
}

export function useHasTechnicalManagementAccess(vesselId?: string) {
  return useHasScope(
    ExactScopeName.technicalManagement,
    ...(vesselId ? [`vessel:${vesselId}:crew`] : []),
  )
}

export function useHasEntityRole(entity: string, role: string) {
  const { data } = useGetMe()
  return data?.scope.some(
    (item) => item.startsWith(`${entity}:`) && item.endsWith(`:${role}`),
  )
}
